/**
 * Ready-made notifications for the push composer: one tap fills the title
 * and message, staff edit and send. Parts in [brackets] are blanks to fill
 * in; the composer will not send while one is left (see PLACEHOLDER).
 *
 * `link` is the tap target that usually suits the message. It is applied
 * only while the composer still says "Just open the app", so it never
 * overrides a choice staff already made.
 *
 * Kept under the composer's guides (50 / 150 characters) so a template shows
 * in full on a phone before anyone edits it.
 *
 * Nothing here repeats what goes out on its own: back-in-stock and price-drop
 * alerts (wishlist) and the free-delivery nudge (cart reminders) are automatic.
 */

export const PLACEHOLDER = /\[[^\]]+\]/;

export const PUSH_TEMPLATES = [
  {
    id: 'new_arrivals',
    label: {en: 'New arrivals', ar: 'وصل حديثاً'},
    link: 'brand',
    en: {title: 'New from [brand] ✨', body: 'Just landed at Nysmah. Be the first to try it.'},
    ar: {title: 'جديد من [الماركة] ✨', body: 'وصل للتو إلى نسمة. كن أول من يجربه.'},
  },
  {
    id: 'discount',
    label: {en: 'Discount', ar: 'خصم'},
    link: 'category',
    en: {title: '[X]% off [category] 🏷️', body: 'For a limited time only. Shop your favourites now.'},
    ar: {title: 'خصم [X]% على [الفئة] 🏷️', body: 'لفترة محدودة فقط. تسوّق مفضلاتك الآن.'},
  },
  {
    id: 'last_chance',
    label: {en: 'Last chance', ar: 'الفرصة الأخيرة'},
    link: 'offer',
    en: {title: 'Last chance ⏳', body: '[offer] ends tonight. Don’t miss it.'},
    ar: {title: 'الفرصة الأخيرة ⏳', body: 'ينتهي [العرض] الليلة. لا تفوّته.'},
  },
  {
    id: 'coupon',
    label: {en: 'Coupon code', ar: 'كود خصم'},
    link: '',
    en: {title: 'A gift for you 🎁', body: 'Use code [CODE] for [X]% off your next order.'},
    ar: {title: 'هدية لك 🎁', body: 'استخدم الكود [الكود] واحصل على خصم [X]% على طلبك القادم.'},
  },
  {
    id: 'ramadan',
    label: {en: 'Ramadan', ar: 'رمضان'},
    link: '',
    en: {title: 'Ramadan Kareem 🌙', body: 'Discover our Ramadan picks and gifts for your loved ones.'},
    ar: {title: 'رمضان كريم 🌙', body: 'اكتشف مختاراتنا لرمضان وهدايا لمن تحب.'},
  },
  {
    id: 'eid',
    label: {en: 'Eid', ar: 'العيد'},
    link: '',
    en: {title: 'Eid Mubarak ✨', body: 'Celebrate with our Eid gift picks. Order now to receive them before Eid.'},
    ar: {title: 'عيد مبارك ✨', body: 'احتفل مع مختاراتنا لهدايا العيد. اطلب الآن ليصلك قبل العيد.'},
  },
  {
    id: 'national_day',
    label: {en: 'National Day', ar: 'اليوم الوطني'},
    link: '',
    en: {title: 'Happy Saudi National Day 💚', body: 'Celebrate with special offers on your favourite scents.'},
    ar: {title: 'كل عام والوطن بخير 💚', body: 'احتفل معنا بعروض خاصة على عطورك المفضلة.'},
  },
  {
    id: 'white_friday',
    label: {en: 'White Friday', ar: 'الجمعة البيضاء'},
    link: 'offer',
    en: {title: 'White Friday is here 🛍️', body: 'Our biggest offers of the year, up to [X]% off.'},
    ar: {title: 'الجمعة البيضاء بدأت 🛍️', body: 'أكبر عروض السنة، بخصم يصل إلى [X]%.'},
  },
];
